import React, { useState } from 'react'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import { displayNameWithSpace } from '../../Utilities/japaneseStringUtils'
import { Typography, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Button, Collapse, Alert, TablePagination, Divider } from '@mui/material'
import UserSearch from '../AdminSettings/UserSearch'

const EditSupportStaffs = ({store, supportStaffs, setSupportStaffs, employments }) => {
    const [successMessage, setSuccessMessage] = useState('')
    const [showSuccess, setShowSuccess] = useState(false)
    const [page, setPage] = useState(0)
    const [rowsPerPage] = useState(10)

    const handleAddSupportStaff = (user) => {
        AxiosWithAuth.post('/employments', {
            user_id: user.id,
            store_id: store.id,
            support_staff: true
        }).then(res => {
            res.data.user = user
            setSuccessMessage(`${displayNameWithSpace(user)}さんをサポートメンバーとして追加しました`)
            setShowSuccess(true)
            setSupportStaffs(prev => [...prev, res.data])
            setTimeout(() => {
                setShowSuccess(false)
            }, 5000)
        })
    }
    const customActionButton = (user) => {
        return <Button 
            variant="contained" 
            color="primary" 
            disabled={supportStaffs.some(staff => String(staff.user.id) === String(user.id)) || employments?.some(employment => String(employment.user.id) === String(user.id))} 
            onClick={e => {
                e.stopPropagation()
                handleAddSupportStaff(user)
            }}
        >
            追加
        </Button>
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    return (
        <>
            <Typography variant="h6" component="div"  margin="1rem" sx={{ width: '50%', marginLeft: "2rem", marginRight: "auto"}}>
                {store.name}のサポートメンバー
            </Typography>
            <Divider />
            <Collapse in={showSuccess}>
                <Alert
                    severity="success"
                    onClose={() => setShowSuccess(false)}
                    sx={{ mt: 2 }}
                >
                    {successMessage}
                </Alert>
            </Collapse>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>名前</TableCell>
                            <TableCell>社員番号</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {supportStaffs && [...supportStaffs]
                            .sort((a, b) => b.id - a.id)
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map(staff => (
                                <TableRow key={staff.id}>
                                    <TableCell>{displayNameWithSpace(staff.user)}</TableCell>
                                    <TableCell>{staff.user.emp_cd}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={supportStaffs.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[10]}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
                />
                <Typography variant="h6" component="div"  margin="1rem" sx={{ width: '50%', marginLeft: "2rem", marginRight: "auto"}}>サポートメンバーを追加</Typography>
                <Divider />
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <UserSearch 
                        history={history}
                        customActionButton={customActionButton}
                    />
                </div>
            </TableContainer>
            
        </>
    )
}

export default EditSupportStaffs